module.exports = __webpack_public_path__ + "static/img/207.23ec268.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/207.jpg
// module id = mPGz
// module chunks = 0